// removed by extract-text-webpack-plugin
module.exports = {"item":"_1XL2WYHm"};


//////////////////
// WEBPACK FOOTER
// ./app/orders/components/date-selection/date-selection.styles.scss
// module id = 692
// module chunks = 0